import React, {useEffect, useMemo} from "react";
import {observer} from "mobx-react-lite";
import type {GridRenderHeaderFilterProps} from "@mui/x-data-grid-premium";
import {useStores} from "../../../../../../stores";
import {FormControl, InputAdornment, InputLabel, OutlinedInput} from "@mui/material";
import {debounceTime, Subject, tap} from "rxjs";
import {Sync} from "@mui/icons-material";

const LABEL = 'Search';
const SEARCH_DELAY_MS = 500;

export const SupplierFilter: React.FC<GridRenderHeaderFilterProps> = observer((props) => {
    const item = props.item;

    const {categorizationReviewStore} = useStores()
    const filterController = categorizationReviewStore.reviewPageController.reviewPageFilterController;

    const [inputValue, setInputValue] = React.useState(filterController.supplierFilterValue)
    const [isLoading, setIsLoading] = React.useState(false)
    const pipe = useMemo(() => new Subject<string>(), [])

    const handleChange = React.useCallback((event: React.ChangeEvent<{value: unknown}>) => {
        const inputValue = event.target.value as string;
        setInputValue(inputValue);
        setIsLoading(true);
        pipe.next(inputValue);
    }, [setInputValue, setIsLoading, pipe]);

    useEffect(() => {
        const sub = pipe.pipe(
            debounceTime(SEARCH_DELAY_MS),
            tap(search => {
                const filterController = categorizationReviewStore.reviewPageController.reviewPageFilterController;
                filterController.onApplyGroupSearch(item, search);
            }),
        ).subscribe({
            next: () => setIsLoading(false),
        });
        return () => {
            sub.unsubscribe();
            // setIsLoading(false);
        };
    }, [pipe, setIsLoading, categorizationReviewStore]);

    useEffect(() => {
        // Component should respond to clearing filter
        if (filterController.supplierFilterValue === '')
            setInputValue(filterController.supplierFilterValue);
    }, [filterController.supplierFilterValue]);


    return (
        <FormControl variant="outlined" size="small" fullWidth>
            <InputLabel id="group-by-filter-label" htmlFor="group-by-filter" shrink>
                {LABEL}
            </InputLabel>
            <OutlinedInput
                // ref={props.inputRef}
                tabIndex={props.tabIndex}
                id="group-by-filter"
                aria-labelledby="group-by-filter-label"
                label={LABEL}

                // TODO: Something weird is still happening here when clearing the filters
                value={inputValue || (item.value ? String(item.value) : '') || ''}
                onChange={handleChange}

                notched
                inputProps={{sx: {fontSize: 14}}}
                endAdornment={isLoading ? <InputAdornment position="end"><Sync/></InputAdornment> : null}
                {...props.InputComponentProps}
            />
            {/*{props.showClearIcon}*/}
        </FormControl>
    );
});